import React from "react";
import { INoticeDetails } from "../../../models/interfaces/INotice";
import RowDetail from "../components/detail/RowDetail";

interface IProps {
  NoticeResult: INoticeDetails;
}

const Bloc6: React.FC<IProps> = ({ NoticeResult }) => {
  return (
    <>
    {(NoticeResult?.notes?.length > 0 || NoticeResult?.collection?.length > 0 || NoticeResult?.serie?.length > 0) && (
      <>
        <div className="card" style={{ textAlign: 'left' }}>
        <div className="col-sm-12 card-body">
        {NoticeResult?.notes?.length > 0 && NoticeResult.notes.map((NoteItem, index) => (
            <RowDetail key={index} titre={NoteItem?.type?.libelleNote} donnee={NoteItem?.contenuNote} />
          ))}
          {NoticeResult?.collection?.length > 0 && (
            <div className="row">
              <div className="col-4 pae-detail-label" style={{ textAlign: 'left' }}>
                <b>Collection</b>
              </div>
              <div className="col-8" style={{ textAlign: 'left' }}>
                <i>
                  {NoticeResult.collection.map((collectionItem, index) => (
                    <div key={index}>
                      {collectionItem.libelleCollection} {collectionItem.noDeCollection && <>n° {collectionItem.noDeCollection}</>}
                      {collectionItem.sousCollection?.libelleSousCollection && (
                        <>
                          . {collectionItem.sousCollection?.libelleSousCollection} {collectionItem.sousCollection?.noDeSousCollection && <>n° {collectionItem.sousCollection?.noDeSousCollection}</>}
                        </>
                      )}
                      {collectionItem.sousCollection?.sousSousCollection?.libelleSousSousCollection && (
                        <>
                          . {collectionItem.sousCollection?.sousSousCollection?.libelleSousSousCollection} {collectionItem.sousCollection?.sousSousCollection?.noDeSousSousCollection && <>n° {collectionItem.sousCollection?.sousSousCollection?.noDeSousSousCollection}</>}
                        </>
                      )}
                    </div>
                  ))}
                </i>
              </div>
            </div>
          )}
          {NoticeResult?.serie?.length > 0 && (
            <div className="row">
              <div className="col-4 pae-detail-label" style={{ textAlign: 'left' }}>
                <b>Série</b>
              </div>
              <div className="col-8" style={{ textAlign: 'left' }}>
                <i>
                  {NoticeResult.serie.map((serieItem, index) => (
                    <div key={index}>
                      {serieItem.titreSerie} {serieItem.numeroSerie && <>n° {serieItem.numeroSerie}</>}
                    </div>
                  ))}
                </i>
              </div>
            </div>
          )}
        </div>
      </div>
      <br />
      </>
    )}
    </>
  );
};

export default Bloc6;
